import React from 'react';

const Arts = ({className, style, settings}) => (
  <div className={className} style={{...style}}>
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><circle id="a" cx={18} cy={18} r={18} /></defs><g transform="translate(-349.000000, -1088.000000) translate(49.000000, 1038.000000) translate(0.000000, 50.000000) translate(300.000000, 0.000000)" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd"><use fill="#A7D4EE" xlinkHref="#a" /><g mask="#444"><g transform="translate(13.354839, 5.225806)"><path d="M4.777 0H1.93C0 0 0 .98 0 .98V18.96l4.645 6.587 4.645-6.587V.98S9.29 0 7.362 0h-2.85" stroke="#333" strokeWidth="1.296" /><path d="M0 4.645s1.516.58 4.571.58c3.056 0 4.72-.58 4.72-.58M0 19.161s1.516.58 4.571.58c3.056 0 4.72-.58 4.72-.58M2.612 5.226v14.516M6.677 5.226v14.516" stroke="#333" strokeWidth="1.296" /><polygon fill="#333" points="2.90322581 23.8064516 5.80645161 23.8064516 4.3550977 26.1290323" /></g></g></g></svg> 
  </div>
);

Arts.defaultProps = {
  style: {
    position:"absolute",
    zIndex:"0",
    bottom:0,
    right:1,
  },
};
export default Arts;
